module.exports = __webpack_public_path__ + "static/media/08_crisalide.119bd58b.jpg";